import localize from '@/core/shared/localization';

export const i18n = localize(window.sbvrenv.BROWSER_LOCALE, 'station');
